import useSWRMutation from "swr/mutation";
import { useDeleter, SWRApiError } from "./swr";

export const useDeleteStructure = () => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, { id: string; mask_id?: string }>(
    "/structures",
    deleter,
  );
};
